/* eslint-disable react/display-name */
import BaseDisclaimerLink from '../BaseDisclaimerLink';
import BaseDisclaimer from '../BaseDisclaimer';

export const createDisclaimer = ({ id, indicator, body }) => ({
  id,
  indicator,
  Link: () => <BaseDisclaimerLink elementId={id} indicator={indicator} />,
  Body: () => (
    <BaseDisclaimer id={id}>
      {indicator} {body}
    </BaseDisclaimer>
  ),
});
